<div class="modal-content">
  <div class="modal__content">
    <div class="modal__header">
      <h3 class="h3 modal__title">Autenticación de tarjeta</h3>
      <button
        (click)="onClickClose()"
        type="button"
        class="modal__close"
        data-bs-dismiss="modal"
        attr.aria-label="{{ 'common.close' | translate }}"
      >
        <img src="assets/images/icons/close.svg" alt="" />
      </button>
    </div>

    <div class="modal__body">
      <iframe
        [src]="targetUrl"
        frameborder="0"
        style="overflow: hidden; height: 500px; width: 100%"
        height="500px"
        width="100%"
      ></iframe>
    </div>
  </div>
</div>
